import { Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import { DownloadDesktopClientButton } from "@/components/download-desktop-client-button";
import { cancelButtonText } from "@/translations";

interface ProjectFileNoDesktopClientModalProps {
  onClose: () => void;
}

export function ProjectFileNoDesktopClientModal({ onClose }: ProjectFileNoDesktopClientModalProps) {
  const intl = useIntl();

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={intl.formatMessage({
        id: "header.no_desktop_client",
        defaultMessage: "No Desktop Client installed",
      })}
      maxW="xl"
      h="fit"
      buttons={[
        {
          children: cancelButtonText,
          variant: "tertiary",
          onClick: onClose,
        },
        <DownloadDesktopClientButton key="key" variant="primary" />,
      ]}
    >
      <Text>
        <FormattedMessage
          id="message.install_below"
          defaultMessage="You can install it with the button below"
        />
      </Text>
    </RanaModal>
  );
}
